// import * as Prismic from 'prismic-javascript';

// import * as PrismicDom from 'prismic-dom';

interface IDoc {
    id: string;
    uid: string;
    type: string;
    tags: any[];
    lang: string;
    isBroken: boolean;
}


export const linkResolver = (doc: IDoc) => {
    return '/doc/' + doc.id;
};

export const htmlSerializer = (element: any, content: any) => {
    if (element === 'image' && !content.linkTo) {
        return `<image-container url="${content.url}" alt="${content.alt}" />`;
    }

    if (element === 'heading6') {
        let text: string = content.text;
        if (content.spans.length > 0) {
            for (const span of content.spans) {
                text = text.slice(0, span.start) + '<' + span.type + '>' +
                    text.slice(span.start, span.end) + '</' + span.type + '>' + text.slice(span.end);
            }
        }
        return `<blockquote>${text}</blockquote>`;
    }

    return null;
};
